import ApolloClient from 'apollo-boost';

const client = new ApolloClient({
  fetchOptions: { fetch },
  uri: process.env.REACT_APP_GRAPHQL_URI || 'http://127.0.0.1/graphql',
});

export { client };
